import { CoverPageOfferFragment, OfferKind } from "@pathwright/graphql-client/src/generated"

export function getCoverPageOfferPosition(offer: CoverPageOfferFragment) {
  return offer.position || null
}

export function isPrivateCohortOffer(offer: CoverPageOfferFragment) {
  return offer.kind === OfferKind.CreateCohort
}

export function isCohortStoreOffer(offer: CoverPageOfferFragment) {
  return offer.kind === OfferKind.JoinCohort
}

// create_cohort offers without an explicit position are sorted to the end of the list.
export function sortCoverPageOffers(offers: CoverPageOfferFragment[]) {
  return [...offers].sort((firstOffer, secondOffer) => {
    const firstPosition = getCoverPageOfferPosition(firstOffer)
    const secondPosition = getCoverPageOfferPosition(secondOffer)

    if (firstPosition && secondPosition) {
      if (firstPosition < secondPosition) return -1
      if (firstPosition > secondPosition) return 1
      return 0
    }

    if (firstPosition) return -1
    if (secondPosition) return 1

    return 0
  })
}
